/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*********************************!*\
  !*** ./src/js/swiper-mobile.js ***!
  \*********************************/
var popularSwiper = null;
setTimeout(function () {
  if (typeof Swiper != "undefined") {
    var setSlideHeight = function setSlideHeight(that) {
      $('.swiper-slide').css({
        height: 'auto'
      });
      var currentSlide = that.activeIndex;
      var newHeight = $(that.slides[currentSlide]).height();
      $('.swiper-wrapper,.swiper-slide').css({
        height: newHeight
      });
      that.update();
    };

    popularSwiper = new Swiper(".mySwiper", {
      direction: "horizontal",
      autoHeight: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      on: {
        init: function init() {
          var _this = this;

          setTimeout(function () {
            setSlideHeight(_this);
          }, 500);
        },
        slideChangeTransitionEnd: function slideChangeTransitionEnd() {
          setSlideHeight(this);
        },
        reachEnd: function reachEnd() {
          var _this2 = this;

          if (this.slides.length > 1) {
            this.el.classList.add('swiper-no-swiping'); // Second way:

            setTimeout(function () {
              //this.allowSlideNext = false                   
              //this.el.classList.add('swiper-no-swiping');
              _this2.el.classList.remove('swiper-no-swiping');
            }, 2000);
          }
        }
      }
    });
  }
}, 500);
/******/ })()
;